import React from 'react';
import { Link } from 'react-router-dom';
const Privacy = () => (
  <div className="min-h-screen bg-gray-50 p-6">
    <div className="max-w-3xl mx-auto bg-white rounded-2xl p-8 shadow-sm">
      <Link to="/" className="text-sm mb-6 block" style={{ color: '#B8860B' }}>← Back</Link>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
      <div className="text-gray-600 text-sm space-y-4">
        <p>Last updated: January 2026</p>
        <h2 className="text-lg font-semibold text-gray-900">1. Data Controller</h2>
        <p>AG VAULT s.r.o., Lučenec, Slovak Republic. Contact: info@bullionx.eu</p>
        <h2 className="text-lg font-semibold text-gray-900">2. Data We Collect</h2>
        <p>Company name, email address, country, shipping address, phone number, and trading activity.</p>
        <h2 className="text-lg font-semibold text-gray-900">3. How We Use Your Data</h2>
        <p>To operate the platform, facilitate trades, send notifications, and comply with legal obligations.</p>
        <h2 className="text-lg font-semibold text-gray-900">4. GDPR</h2>
        <p>We process data in accordance with the EU General Data Protection Regulation (GDPR).</p>
      </div>
    </div>
  </div>
);
export default Privacy;
